import React from "react";
import SurveyTextInput from './SurveyTextInput';
import SurveySelect from './SurveySelect';
import SurveyNumberInput from './SurveyNumberInput';
import SurveyTextArea from './SurveyTextArea';
import SurveyGrid from './GridComponents/SurveyGrid';
import SurveyLabelField from './SurveyLabelField'
import SurveyRadioButton from './SurveyRadioButton'
import SurveyCheckbox from "./SurveyCheckbox";
import SurveyCalculatedField from './SurveyCalculatedField'
import { observer } from "mobx-react";
import store from '../components/Stores/SurveyStore';
import { ElementType } from "../Enums/constants";
import {
    Tooltip,
} from 'react-tippy';
import { hiddenContentCheck } from "../Helpers/General/HiddenContentHelper";
const BlankComponent = () => {
    return (<br />);
};
const COMPONENTS = {
    grid: SurveyGrid,
    text: SurveyTextInput,
    date: SurveyTextInput,
    number: SurveyNumberInput,
    label: SurveyLabelField,
    textArea: SurveyTextArea,
    select: SurveySelect,
    calculated: SurveyCalculatedField, 
    radiobutton: SurveyRadioButton,
    checkbox: SurveyCheckbox
};

const SurveyElement = observer((props) => {
    if (props.name && store.surveyMappingObj[props.pageName] && store.surveyMappingObj[props.pageName].indexOf(props.name) == -1) {
        store.surveyMappingObj[props.pageName].push(props.name); 
    }

    var Component = COMPONENTS[props.inputType] || BlankComponent;
    var styling = !props.inputType ? "textLabel " : "questionTextLabel ";

    if (props.subQuestion) styling += "subTextLabel ";
    if (props.doubleSubQuestion) styling += "doubleSubTextLabel "; 

    const clickMoreInfo = () => {
        store.additionalInfoPanel.name = props.moreInfoId;
        store.additionalInfoPanel.visible = true;
    }

    const renderInfoButton = () => {
        var positionTooltip = props.formatInfoBtn;
        if (props.tooltip) positionTooltip = props.tooltip;
        if (positionTooltip == null) positionTooltip = "bottom";
        if (props.helpText || props.moreInfoId) {
            return (
                <Tooltip
                    position={positionTooltip}
                    trigger="mouseenter"
                    animation="fade"
                    arrow="true"
                    interactive="true"
                    hideOnClick="false"
                    html={(
                        <div className="genericTooltip" >
                            {props.helpText &&
                                <span dangerouslySetInnerHTML={{ __html: props.helpText }} ></span>
                            }
                            {props.moreInfoId &&
                                <span style={{ color: '#ade4d0' }}>Click for additional info</span>
                            }
                        </div>
                    )}
                    >

                    {props.moreInfoId &&
                        <i className="fas fa-info-circle fa-xs" onClick={clickMoreInfo}></i>

                    }
                    {
                        !props.moreInfoId &&
                        <i className="fas fa-info-circle fa-xs"></i>
                    }

                </Tooltip>
                );
        }
    }

    const renderQuestionNumber = () => {
        if (props.questionNumber) {
            var questionNumParts = props.questionNumber.split(".");
                return <React.Fragment>{questionNumParts[questionNumParts.length-1]}.&nbsp;</React.Fragment>;
        }
        
    }



    //For tables, we do not need to use rows/col for formatting, also for blocks of text
    if (!props.labelText || props.inputType == ElementType.LABEL || !props.inputType || props.inputType == ElementType.TEXTAREA) {
        var wrapStyle=""
        if (props.wrap) wrapStyle = " wrap"
        let hideTrigger = hiddenContentCheck(props)
        
        return (
            <div className={props.inputType ? "surveyRow " + wrapStyle : "surveyRow  labelOnly" + wrapStyle} hidden={hideTrigger} >
                {props.labelText &&
                    <span className={styling}>
                    {props.formatInfoBtn == "left" && renderInfoButton()}
                    {renderQuestionNumber()}
                    <span className={[props.smallFont ? "smallFont questionTextContent" : "questionTextContent", props.isConditional ? "conditionalQuestion" : ""]} dangerouslySetInnerHTML={{ __html: props.labelText }} ></span>
                    {props.formatInfoBtn!="left" && renderInfoButton()}
                    {props.note &&
                        <React.Fragment><br /> <div className="note" dangerouslySetInnerHTML={{ __html: props.note }} ></div> </React.Fragment>
                    }
                    </span>
                }
               
                < Component {...props}></Component >
            </div>
        );
    }

    else {
        //Regular question format
       let hideTrigger = hiddenContentCheck(props)
        return (
            <div className="surveyRow row" hidden={hideTrigger} >
                <div className="questionLabel ">
                    <span className={`${styling} ${props.styleName}`}>
                        {renderQuestionNumber()}
                        <span className={["questionTextContent", props.isConditional ? "conditionalQuestion" : ""].join("")} dangerouslySetInnerHTML={{ __html: props.labelText }}></span>
                        {(props.helpText || props.moreInfoId) &&

                            <Tooltip
                                position="bottom"
                                trigger="mouseenter"
                                animation="fade"
                                arrow="true"
                                interactive="true"
                                hideOnClick="false"
                                html={(
                                    <div className="genericTooltip" style={{ whiteSpace: 'pre-wrap' }}>
                                        <span dangerouslySetInnerHTML={{ __html: props.helpText }} ></span>

                                    </div>
                                )}
                            >
                                <i className="fas fa-info-circle fa-xs" ></i>
                            </Tooltip>
                        }
                        {props.note &&
                            <React.Fragment><br /> <div className="note" dangerouslySetInnerHTML={{ __html: props.note }} ></div> </React.Fragment>
                        }
                    </span>
                </div>
                    <Component {...props}></Component>

            </div>
        );
    };
});
export default SurveyElement;




